import { Phone, MessageSquare, Globe, Mail, Headset } from 'lucide-react'
import { FacebookIcon, WhatsAppIcon, InstagramIcon, YouTubeIcon, XIcon, TelegramIcon } from './BrandIcons.js'

export type ChannelIconComponent = React.ComponentType<{ className?: string }>

export interface ChannelConfig {
  icon: ChannelIconComponent
  label: string
  color: string
  bg: string
}

export const CHANNEL_CONFIG: Record<string, ChannelConfig> = {
  voice: { icon: Phone, label: 'Voice', color: 'text-emerald-600', bg: 'bg-emerald-50' },
  whatsapp: { icon: WhatsAppIcon, label: 'WhatsApp', color: 'text-green-600', bg: 'bg-green-50' },
  telegram: { icon: TelegramIcon, label: 'Telegram', color: 'text-blue-500', bg: 'bg-blue-50' },
  facebook: { icon: FacebookIcon, label: 'Facebook', color: 'text-blue-600', bg: 'bg-blue-50' },
  instagram: { icon: InstagramIcon, label: 'Instagram', color: 'text-pink-600', bg: 'bg-pink-50' },
  sms: { icon: MessageSquare, label: 'SMS', color: 'text-gray-600', bg: 'bg-gray-50' },
  email: { icon: Mail, label: 'Email', color: 'text-orange-600', bg: 'bg-orange-50' },
  chat: { icon: Headset, label: 'Web', color: 'text-indigo-600', bg: 'bg-indigo-50' },
  web: { icon: Globe, label: 'Web', color: 'text-indigo-600', bg: 'bg-indigo-50' },
  youtube: { icon: YouTubeIcon, label: 'YouTube', color: 'text-red-600', bg: 'bg-red-50' },
  x: { icon: XIcon, label: 'X', color: 'text-gray-900', bg: 'bg-gray-100' },
}

export const DEFAULT_CHANNEL_CONFIG: ChannelConfig = {
  icon: MessageSquare,
  label: 'Chat',
  color: 'text-gray-500',
  bg: 'bg-gray-100',
}

export function getChannelConfig(origin?: string | null): ChannelConfig {
  return CHANNEL_CONFIG[origin ?? ''] ?? DEFAULT_CHANNEL_CONFIG
}
